import { SessionStatus, type KioskSessionView } from '@print-saas/shared';
import { ClockIcon } from '../components/icons';
import { MessageScreen } from '../components/MessageScreen';

/** EXPIRED / CANCELLED: brief hand-over until the server pushes the next QR. */
export function SessionEndedScreen({ session }: { session: KioskSessionView }) {
  const cancelled = session.status === SessionStatus.CANCELLED;
  return (
    <MessageScreen
      tone="muted"
      icon={<ClockIcon />}
      title={cancelled ? 'Order cancelled' : 'Session ended'}
      subtitle="Getting a fresh code for the next customer…"
    />
  );
}
